'use client';

import { AMENITIES } from '@src/v3/constants/amenities';
import Button from '@src/v3/components/coreUI/button';
import React from 'react';
import clsx from 'clsx';
import { AmenitiesDropdownProps } from '@src/v3/interfaces/components/coreUI/filterDropdown/amenitiesDropdown';

const AmenitiesDropdown: React.FC<AmenitiesDropdownProps> = ({
  selectedAmenities = [],
  onAmenitiesChange,
  containerClassName = '',
}) => {
  const handleAmenityToggle = (amenityId: string) => {
    const newSelection = selectedAmenities.includes(amenityId)
      ? selectedAmenities.filter((id) => id !== amenityId)
      : [...selectedAmenities, amenityId];
    onAmenitiesChange?.(newSelection);
  };

  const isSelected = (amenityId: string) => {
    return selectedAmenities.includes(amenityId);
  };

  return (
    <div className={containerClassName}>
      <div className="flex flex-col gap-y-9">
        {/* Header */}
        <div className="flex flex-col">
          <span className="text-xl font-medium text-black-dark">Amenities</span>
        </div>

        <div className="flex flex-col gap-y-6">
          {/* Amenities Layout */}
          <div className="flex flex-wrap gap-3">
            {AMENITIES.map(({ key, name, icon }) => {
              const Icon = icon;
              return (
                <Button
                  key={key}
                  onClick={() => handleAmenityToggle(key)}
                  className={clsx(
                    isSelected(key)
                      ? 'border border-primary-dark bg-primary-lighter text-black-dark/90 hover:bg-primary-lighter'
                      : 'border-transparent bg-gray-lighter hover:bg-gray-light text-gray-dark ',
                    'shadow-none px-4 py-3 h-11 flex items-center rounded-[100px] gap-x-2 text-base font-medium transition-colors flex-shrink-0'
                  )}
                >
                  <Icon width="20" height="20" />
                  <span className="flex-1 text-left">{name}</span>
                </Button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmenitiesDropdown;
